export default {
  data() {
    return {
      startDate: '',
      endDate: '',
    };
  },
  computed: {
    currentBoard() {
      return this.$store.getters.currentBoard;
    },
    reportInfoData() {
      return this.$store.getters.getReportInfoData;
    },
  },
  methods: {
    getLastNDays(selectedItemId) {
      const n = parseInt(selectedItemId);
      const today = new Date();
      this.endDate = Math.floor(today.getTime() / 1000);
      this.startDate = Math.floor(
        new Date(today.getTime() - n * 24 * 60 * 60 * 1000).getTime() / 1000
      );
    },
    fetchReportData() {
      this.$store.dispatch('fetchReport', {
        type: 'cfd',
        board_id: `${this.currentBoard.id}`,
        from: `${this.startDate}`,
        to: `${this.endDate}`,
      });
    },
  },
};
